import { PlanDetailsComponent } from "./components/plan-details/plan-details.component";
import { EditionPlanChangeCtrl } from "./controllers/edition-plan-change";
import { RequiredEmailNotificationCtrl } from "./controllers/required-email-notification";
import { UpgradeEditionPlanCtrl } from "./controllers/upgrade-edition-plan";
import { PricingEditionService } from "./services/pricing-edition.service";

const mod = angular.module("editionPlanChange", []);

mod.controller("EditionPlanChangeCtrl", EditionPlanChangeCtrl);
mod.controller("UpgradeEditionPlanCtrl", UpgradeEditionPlanCtrl);
mod.controller("RequiredEmailNotificationCtrl", RequiredEmailNotificationCtrl);

mod.service("PricingEditionService", PricingEditionService);

mod.component("planDetails", PlanDetailsComponent);

export default mod.name;
